module.exports = __webpack_public_path__ + "img/check-background-blue.35bb15ec.svg";